import React from 'react';
import './counters.scss';

import {handleAuthError, useCheckUserAuthentication,fetchLookup, tipoDocOptions} from '../../globals';

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  Lookup,
  Editing,
  Selection,
  SearchPanel
} from 'devextreme-react/data-grid';

import { useState, useEffect } from "react";

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Contatore'

const remoteDataSource = createStore({
  key: 'id',
  loadUrl: serviceUrl + '/GetAction',
  insertUrl: serviceUrl + '/InsertAction',
  updateUrl:serviceUrl + '/UpdateAction',
  deleteUrl: serviceUrl + '/DeleteAction'
  
});

export default function Counters() {

  const [societa, setSocieta] = useState({});

  const user = useCheckUserAuthentication();

  useEffect(() => {
  
    const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
    var newUrl1 =  newServiceUrl1 + "/GetIntermediari";

    const fetchData = async () => {

      if (!user?.token) {
        return;
      }

      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const json1 = await fetchLookup(newUrl1,requestOptions);
        if (json1) {
          setSocieta(json1);
        }

      } catch (error) {
        console.log("error", error);
      }
    };
      fetchData();
  }, [user?.token]);


  return(
    <React.Fragment>
      <h2 className={'content-block'}>Contatori</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>
        <DataGrid
          dataSource={remoteDataSource}
          focusedRowEnabled={true}
          >
          <SearchPanel visible={true} width={240} placeholder="Cerca..." />
          <Selection mode="single" />
          <Editing
            mode="row"
            useIcons={true}
            allowAdding={true}
            allowDeleting={true}
            allowUpdating={true}     
          />
          <Column dataField="id" visible={false}/>
          <Column dataField="tipoDocumento"  >
            <Lookup dataSource={tipoDocOptions} displayExpr="desc" valueExpr="id" />
          </Column>
          <Column dataField="tenantId" caption="Azienda" >
            <Lookup dataSource={societa} displayExpr="alias" valueExpr="id" />
          </Column>
          <Column dataField="anno" />
          <Column dataField="numero" caption={"Ultimo Numero Utilizzato"}/>
      
        </DataGrid>  
        </div>
      </div>
    </React.Fragment>
  )
};
